import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    color: ${COLORS.black};
    margin-bottom: 70px;
    @media(max-width: 1620px) {
        margin-bottom: 30px;
    }
    @media(max-width: 530px) {
        margin-bottom: 20px;
    }
`;

export const Prompt = styled.div`
    display: block;
    ${FONTS.L};
    color: ${COLORS.darkGrey};
    margin-bottom: 5px;
    @media(max-width: 1620px) {
        ${FONTS.S};
    }
`;

export const Title = styled.div`
    display: block;
    ${FONTS.H1};
    margin-bottom: 20px;
    @media(max-width: 1620px) {
        ${FONTS.H2};
        margin-bottom: 15px;
    }
    @media(max-width: 1024px) {
        ${FONTS.H3};
        margin-bottom: 10px;
    }
    @media(max-width: 530px) {
        ${FONTS.H4};
    }
`;

export const Description = styled.div`
    display: block;
    ${FONTS.L};
    ol {
        display: block;
        ${FONTS.S};
        list-style-type: decimal;
        padding-left: 18px;
    }
    li {
        margin-bottom: 3px;
    }
    @media(max-width: 1620px) {
        ${FONTS.S};
    }
    @media(max-width: 530px) {
        ${FONTS.XS};
    }
`;
